import { render, staticRenderFns } from "./ModalVideoTutorial.vue?vue&type=template&id=43cd6c45&scoped=true&"
import script from "./ModalVideoTutorial.vue?vue&type=script&lang=js&"
export * from "./ModalVideoTutorial.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoTutorial.vue?vue&type=style&index=0&id=43cd6c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd6c45",
  null
  
)

export default component.exports